module.exports = __webpack_public_path__ + "static/the-halo-effect-271fe9179edc72893260601f4c1518c1.jpg";